<!--NEED REFACTORING-->
<template>
  <v-dialog persistent v-model="isShowModal" max-width="900px">
    <v-card>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout row wrap class="px-2">
            <v-card-text>
              <v-flex xs12>
                <h3 class="text-xs-center py-2 my-2">
                  {{actionListing}} Listing
                </h3>
                <p v-if="actionListing === 'Edit'">
                  <span class="body-2">Status: </span>{{listingStatusProp}}
                </p>
              </v-flex>
              <v-flex xs12>
                <v-layout row class="mb-1">
                  <v-flex xs12 class="text-xs-left py-2 logo-edit">
                    <p>
                      <span class="body-2">Edit logo *: </span>
                    </p>
                    <a-image-cropper
                      @saveEditedImage="saveLogo"
                      :setImgUrl="listingMetadata.logo"></a-image-cropper>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12>
                <v-layout row class="mb-1">
                  <v-flex xs5 class="text-xs-center py-2">
                    <content-field
                      label="Name *"
                      v-model="listingInvitation.name"
                      @input="$v.listingInvitation.name.$touch"
                      @blur="$v.listingInvitation.name.$touch"
                      :error="$v.listingInvitation.name"
                    />
                  </v-flex>
                  <v-flex xs5 offset-xs2 class="text-xs-center py-2">
                    <content-field
                      label="Company *"
                      v-model="listingInvitation.company"
                      @input="$v.listingInvitation.company.$touch"
                      @blur="$v.listingInvitation.company.$touch"
                      :error="$v.listingInvitation.company"
                    />
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12>
                <v-layout row class="mb-1">
                  <v-flex xs5 class="text-xs-center py-2">
                    <content-field
                      label="Email *"
                      v-model="listingInvitation.email"
                      @input="$v.listingInvitation.email.$touch"
                      @blur="$v.listingInvitation.email.$touch"
                      :error="$v.listingInvitation.email"
                    />
                  </v-flex>
                  <v-flex xs5 offset-xs2 class="text-xs-center py-2">
                    <content-field
                      label="Company Email Address"
                      v-model="listingMetadata.companyEmailAddress"
                    />
                  </v-flex>
                  <v-flex xs5 offset-xs2 class="text-xs-center py-2">
                    <content-field
                      label="Telegram"
                      v-model="listingMetadata.telegram"
                    />
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12>
                <v-layout row class="mb-1">
                  <v-flex xs5 class="text-xs-center py-2">
                    <content-field
                      label="Position *"
                      v-model="listingMetadata.title"
                      @input="$v.listingMetadata.title.$touch"
                      @blur="$v.listingMetadata.title.$touch"
                      :error="$v.listingMetadata.title"
                    />
                  </v-flex>
                  <v-flex xs5 offset-xs2 class="text-xs-center py-2">
                    <content-field
                      label="Website *"
                      v-model="listingMetadata.website"
                      @input="$v.listingMetadata.website.$touch"
                      @blur="$v.listingMetadata.website.$touch"
                      :error="$v.listingMetadata.website"
                    />
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12>
                <v-layout row class="mb-1">
                  <v-flex xs5 class="text-xs-center py-2">
                    <content-field
                      label="Phone *"
                      v-model="listingMetadata.phone"
                      @input="$v.listingMetadata.phone.$touch"
                      @blur="$v.listingMetadata.phone.$touch"
                      :error="$v.listingMetadata.phone"
                    />
                  </v-flex>
                  <v-flex xs5 offset-xs2 class="text-xs-center py-2">
                    <content-field
                      label="Phone 2"
                      v-model="listingMetadata.phone2"
                    />
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12>
                <v-layout row class="mb-1">
                  <v-flex xs12 class="text-xs-left py-2 logo-edit">
                    <p>
                      <span class="body-2">Edit photo *: </span>
                    </p>
                    <a-image-cropper
                      @saveEditedImage="savePhoto"
                      :setImgUrl="listingMetadata.photo"></a-image-cropper>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12>
                <v-layout row class="mb-1">
                  <v-flex xs5 class="text-xs-center py-2">
                    <content-field
                      label="CEO"
                      v-model="listingMetadata.CEO"
                    />
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12>
                <content-field
                  label="Offices"
                  :multiLine="true"
                  v-model="listingMetadata.Offices"
                />
              </v-flex>
              <v-flex xs12>
                <form-interpretator
                  v-if="getFormData"
                  :formType="getFormData.type"
                  :formId="getFormData.id"
                  :formGroup="getFormData.group"
                  :formFields="getFormData.fields"
                  :formMetadata="getFormData.metadata"
                  :editableItem="changeObjForFormConstructor"
                  :takeData="takeData"
                  @getData="takeAditionalInformation"
                />
              </v-flex>

              <v-flex xs12 class="text-xs-center py-2">
                <v-btn
                  color="blue darken-1"
                  flat="flat"
                  @click="closeModal()"
                >
                  close
                </v-btn>
                <v-btn
                  color="blue darken-1"
                  flat="flat"
                  @click="saveListing"
                  :disabled="$v.$invalid"
                >
                  save
                </v-btn>
              </v-flex>
            </v-card-text>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
  import { required } from 'vuelidate/lib/validators'
  import { mapActions } from 'vuex'
  import FormInterpretator from '@/components/shared/EvFormInterpretator'
  import AImageCropper from '@/components/shared/AImageCropper'
  import { assocPath } from 'ramda'

  export default {
    name: 'ModalCompanyInfo',
    components: {
      FormInterpretator,
      AImageCropper
    },
    props: {
      isShow: {
        default: false,
        required: true,
        type: Boolean
      },
      listingStatusProp : {
        type: String
      },
      listingInvitationProp: {
        required: true,
        type: Object
      },
      listingMetadataProp: {
        required: true,
        type: Object
      },
      additionalInformationProp: {
        required: true,
        type: Object
      },
      getFormData: {
        type: Object
      },
      id: {
        type: String
      }
    },
    data () {
      return {
        isShowModal: false,
        listingInvitation: {},
        editedLogo: '',
        editedPhoto: '',
        listingMetadata: {
          logo: '',
          photo: '',
          title: '',
          website: '',
          phone: '',
          phone2: '',
          companyEmailAddress: '',
          CEO: '',
          Offices: ''
        },
        additionalInformation: {},
        takeData: false
      }
    },
    validations: {
      listingInvitation: {
        name: { required },
        company: { required },
        email: { required },
      },
      listingMetadata: {
        title: { required },
        website: { required },
        phone: { required }
      }
    },
    computed: {
      actionListing () {
        return this.id ? 'Edit' : 'Add'
      },
      changeObjForFormConstructor () {
        // TODO REFACROTING
        const metadata = { metadata: this.additionalInformation }
        return metadata
      }
    },
    watch: {
      isShow: {
        handler () {
          this.isShowModal = this.isShow
        },
        immediate: true,
      },
      isShowModal (val) {
        if (!val) this.closeModal()
      }
    },
    methods: {
      ...mapActions([
        'createListing',
        'updateListing',
        'updatePendingListing'
      ]),
      saveLogo(imageUrl) {
        this.editedLogo = imageUrl
      },
      savePhoto(imageUrl) {
        this.editedPhoto= imageUrl
      },
      closeModal () {
        this.$emit('close')
      },
      takeAditionalInformation () {
        this.takeData = true
        this.saveListing()
      },
      // BAD LOGIC NEED REFACTORING
      saveListing () {
        if (this.editedPhoto) this.listingMetadata.photo = this.editedPhoto
        if (this.editedPhoto) this.listingMetadata.logo = this.editedLogo
        if (!this.listingMetadata.logo || !this.listingMetadata.photo) return

        if (this.$v.$invalid) return
        this.$emit('done')
        this.chooseListingAction([this.id, {
          listingInvitation: this.listingInvitation,
          listingMetadata: this.listingMetadata,
          additionalInformation: this.additionalInformation
        }
        ])
      },
      async chooseListingAction ([id, newListingInvitation]) {
        id ? this.prepareEditListing(id, newListingInvitation) : this.prepareCreateListing(newListingInvitation)
      },
      async prepareCreateListing (newListing) {
        const body = { ...newListing }
        const invitation = {
          name: newListing.listingInvitation.name,
          company: newListing.listingInvitation.company,
          email: newListing.listingInvitation.email,
          status: 'NotYet'
        }
        try {
          await this.createListing({ body, invitation})
          this.closeModal()
        } catch (err) {
          throw err
        }
      },
      async prepareEditListing (id, editListing) {
        const body = { ...editListing }
        const listing = { id, body }
        try {
          this.listingStatusProp === 'Pending'
            ? await this.updatePendingListing(listing)
            : await this.updateListing([listing])
          this.closeModal()
        } catch (err) {
          throw err
        }
      },
    },
    // NEED FOR LISTING UPDATE DATE FROM FORMINTERPRETATOR
    mounted () {
      this.$bus.$on('customFormInput', (e) => {
        this.additionalInformation = assocPath(e.path, e.value, this.additionalInformation)
      })
    },
    destroyed () {
      this.$bus.$off('customFormInput')
    },
    created () {
      // TODO NEED REFACTORING
      Object.assign(this.listingInvitation, this.listingInvitationProp)
      Object.assign(this.listingMetadata, this.listingMetadataProp)
      Object.assign(this.additionalInformation, this.additionalInformationProp)
    }
  }
</script>

<style lang="scss" scoped>

  .logo-edit /deep/ .ch-file-btn__input {
    position: static;
    left: unset;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/Listing/ListingList/modalCompanyInfo.vue